import { render, staticRenderFns } from "./PetDetailOwner.vue?vue&type=template&id=7397c124&scoped=true&"
import script from "./PetDetailOwner.vue?vue&type=script&lang=js&"
export * from "./PetDetailOwner.vue?vue&type=script&lang=js&"
import style0 from "./PetDetailOwner.vue?vue&type=style&index=0&id=7397c124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7397c124",
  null
  
)

export default component.exports